<template>
  <v-dialog v-model="mostrar" max-width="500px" persistent>
    <v-card>
        <v-toolbar
        color="blue-grey darken-1"
        dense
        dark
        flat
        class="text-h5"
        height="60px"
      >Cambiar orden oficios</v-toolbar>
			<v-container>
				<!-- CAMBIAR ORDEN OFICIOS -->
				<v-list>
					<draggable
						v-model="historicoOficios"
						v-bind="dragOptions"
            @change="cambiarOrden"
					>
						<template v-for="oficio in historicoOficios" >
							<v-card :key="oficio._id" outlined flat tile v-if="!oficio.comentario.mensaje" :disabled="loading">
								<v-expansion-panels accordion flat tile>
									<v-expansion-panel>
										<v-expansion-panel-header style="padding: 5px;">
											<v-list-item aria-hidden="true" class="item-seccion pl-0" >
												<v-list-item-avatar class="mr-0">
													<v-btn icon style="cursor: move;">
														<v-icon>mdi-dots-grid</v-icon>
													</v-btn>
												</v-list-item-avatar>
												<v-list-item-content style="width: 10px">
													<v-list-item-title>{{ numeroOficio(oficio) }}</v-list-item-title>
												</v-list-item-content>
											</v-list-item>
										</v-expansion-panel-header>
										<v-expansion-panel-content>{{ asuntoOficio(oficio) }}</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>
						</template>
					</draggable>
				</v-list>

        </v-container>
				<!-- CAMBIAR ORDEN OFICIOS -->
				<v-divider class="mx-3"></v-divider>
      	<v-card-actions>
        	<v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs}">
              <v-btn
                color="blue-grey darken-1"
                outlined
                small
                v-bind="attrs"
                v-on="on"
                @click="$emit('cancelar')"
                >Cancelar</v-btn>
            </template><span>Al cancelar se perderán todos los cambios</span>
          </v-tooltip>
					<v-btn
						color="blue-grey darken-1"
						dark
						small
            :loading="loading"
						@click="guardarOrden()"
						>Guardar</v-btn>
      </v-card-actions>

      
    </v-card>

  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import draggable from "vuedraggable";

import { obtenerHistoricoEntranteByIdService, modificarHistoricoEntranteByIdService } from "./oficiosEntrantes.service";
import { obtenerHistoricoGeneradoByIdService, modificarHistoricoGeneradoByIdService } from "./oficiosGenerados.service";

export default {
    name: 'cambiarOrdenOficios',
    props: {
        mostrar: { type: Boolean, default: () => false},
    },
		components: {
			draggable,
		},
		computed: {
      ...mapGetters(["httpURL", "sessionToken", "userId"]),
			dragOptions() {
				return {
					animation: 300,
					disabled: false,
					class: "ghost"
				};
     }
		},
    created() {
      this.idOficio = this.$route.params.id;
      this.tipoOficio = this.$route.params.tipo;
      this.obtenerHistorico();
    },
    data: () => ({
      loading: false,
      mensajeAdvertencia: false,
      idOficio: null,
      tipoOficio: null,
			historicoOficios: [],
    }),
    methods: {
      async obtenerHistorico() {
        try {
          this.loading = true;
          let serverResponse = null;

          if(this.tipoOficio === 'entrante') serverResponse = await obtenerHistoricoEntranteByIdService(this.idOficio);
          else serverResponse = await obtenerHistoricoGeneradoByIdService(this.idOficio);
          this.loading = false;
          if (!serverResponse.ok) throw new Error(serverResponse.mensaje);
          else {
            this.historicoOficios = serverResponse.historico;
          }      
        } catch (error) {
          this.loading = false;
          this.$notificarError(error.message);
        }
      },
			numeroOficio(oficio) {
				if(oficio.oficio.entrante) return oficio.oficio.entrante.numero;
        if(oficio.oficio.generado) return oficio.oficio.generado.numeroCompleto;
			},
			asuntoOficio(oficio) {
				if(oficio.oficio.entrante) return oficio.oficio.entrante.asunto;
        if(oficio.oficio.generado) return oficio.oficio.generado.asunto;
			},
      cambiarOrden(event) {
        if (event) this.mensajeAdvertencia = true;
      },
			async guardarOrden() {
        try {
          this.loading = true;
          let serverResponse = null;
          const data = {
            historico: this.historicoOficios
          };

          if(this.tipoOficio === 'entrante') serverResponse = await modificarHistoricoEntranteByIdService(this.idOficio, data);
          else serverResponse = await modificarHistoricoGeneradoByIdService(this.idOficio, data);

          this.loading = false;
          if (!serverResponse.ok) this.$systemErrorMessage(serverResponse.mensaje);
          else {
            this.$notify({
              group: "gral_notif",
              type: "success",
              duration: 1500,
              speed: 500,
              text: serverResponse.mensaje,
            });

            this.$emit("ordenModificado", this.historicoOficios);
          }
        } catch (error) {
          this.loading = false;
          this.$notificarError(error.message);
        }
			},
			

    }
}
</script>

<style>
.ghost {
  background: #CFD8DC;
}



</style>